<template>
    <div>
        <van-count-down class="count-down"
            :style="styles"
            :time="time"
            format="HH:mm:ss"
            @change="onChange">
            <template v-slot="timeData">
                <span>距领取</span>
                <!-- 大于等于逻辑 - 防止当值为10时显示为010 -->
                <template v-if="time >= 3600000000">
                    <span class="block"
                        :style="blockStyles">999</span>
                    <span class="colon"
                        :style="styles">时</span>
                    <span class="block"
                        :style="blockStyles">59</span>
                    <span class="colon"
                        :style="styles">分</span>
                    <span class="block"
                        :style="blockStyles">59</span>
                    <span class="colon"
                        :style="styles">秒</span>
                </template>
                <template v-else>
                    <span class="block"
                        :style="blockStyles">{{ (timeData.hours+(timeData.days*24)) >= 10 ? (timeData.hours+(timeData.days*24)) : `0${(timeData.hours+(timeData.days*24))}` }}</span>
                    <span class="colon"
                        :style="styles">时</span>
                    <span class="block"
                        :style="blockStyles">{{ timeData.minutes >= 10 ? timeData.minutes : `0${timeData.minutes}` }}</span>
                    <span class="colon"
                        :style="styles">分</span>
                    <span class="block"
                        :style="blockStyles">{{ timeData.seconds >= 10 ? timeData.seconds : `0${timeData.seconds}` }}</span>
                    <span class="colon"
                        :style="styles">秒</span>
                </template>
            </template>
        </van-count-down>
    </div>
</template>

<script>
import { CountDown } from 'vant';
export default {
  components: {
    [CountDown.name]: CountDown,
  },
  props: {
    time: {
      type: Number,
      default: 0,
    },
    countColor: {
      type: String,
      default: '#888888',
    },
    blockColor: {
      type: String,
      default: '#1C1C1C',
    },
    blockBackgroundColor: {
      type: String,
      default: '#E0E0E0',
    },
  },
  computed: {
    styles() {
      const style = {};
      if (this.countColor) {
        style.color = this.countColor;
      }
      return style;
    },
    blockStyles() {
      const style = {};
      if (this.blockBackgroundColor) {
        style.backgroundColor = this.blockBackgroundColor;
      }
      if (this.blockColor) {
        style.color = this.blockColor;
      }
      return style;
    },
  },
  data() {
    return {
      timeData: {},
    };
  },
  methods: {
    onChange(timeData) {
      this.timeData = timeData;
      // 倒计时归零了抛出事件
      if (timeData.days === 0 && timeData.hours === 0 && timeData.minutes === 0 && timeData.seconds === 0 && timeData.milliseconds === 0) {
        this.$emit('timeDownFinished');
      }
    },
  },
};
</script>


<style scoped lang="scss">
.count-down {
  font-size: 12px;
  color: #888888;
  padding: 5px 0px;
  zoom: 87.5%;
  .colon {
    display: inline-block;
    font-size: 12px;
    color: #2f2e35;
    text-align: center;
  }
  .block {
    display: inline-block;
    width: 22px;
    background: #e0e0e0;
    color: #1c1c1c;
    border-radius: 3px;
    font-size: 12px;
    text-align: center;
    font-weight: 500;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/themaicComponent/themaic-count-down.vue